import { RefCodeServiceBase } from './ref-code.service.base';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENVIRONMENT, HateoasMultipleResponseObject } from '@scisys-uim/uim-common';
import { RefCode } from 'assets-model';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class RefCodeService extends RefCodeServiceBase {
  constructor(http: HttpClient, @Inject(ENVIRONMENT) environment: any) {
    super(http, environment);
  }

  public getRefCodesByDomain(domain: string): Observable<HateoasMultipleResponseObject<RefCode>> {
    return this.deserialiseMultipleResponse(this.http.get<HateoasMultipleResponseObject<RefCode>>(this.serviceBaseUrl + "/" + domain));
  }

  public getAllDomains(): Observable<string[]> {
    return this.http.get<string[]>(this.serviceBaseUrl + "/findAllDomains");
  }

}



